import {
  IconCircle,
  IconCircleDot,
  IconDeviceGamepad2,
  IconDice5,
  IconFlame,
  IconGrid3x3,
  IconHeadset,
  IconHome,
  IconHorseshoe,
  IconNews,
  IconPaw,
  IconPoint,
  IconRocket,
  IconShield,
  IconSword,
  IconTargetArrow,
  IconTicket,
  IconTrophy,
  IconVideo,
} from "@tabler/icons-react";
import {useTranslation} from "react-i18next";
import {useUserSupport} from "../../../store/useUserSupport.store";

const ICON_PROPS = {size: 20, stroke: 2};
const SUBMENU_ICON_PROPS = {size: 18, stroke: 2};

export const MenuVertical = () => {
  const {t} = useTranslation();

  const handleSupportModal = useUserSupport(state => state.handleSupportModal);

  const menuVertical = [
    {
      label: t("home"),
      key: "/",
      icon: <IconHome {...ICON_PROPS} />,
    },
    {
      label: t("games"),
      key: "games",
      icon: <IconDeviceGamepad2 {...ICON_PROPS} />,
      children: [
        {
          label: t("allGames"),
          key: "/gameslist/all",
        },
        {
          label: t("providers"),
          key: "providers",
          children: [
            {
              label: "Pragmatic",
              key: "/games/provider/pragmatic",
            },
            {
              label: "Kagaming",
              key: "/games/provider/kaga",
            },
            {
              label: "Hacksaw",
              key: "/games/provider/hacksaw",
            },
            {
              label: "Gaming Corps",
              key: "/games/provider/gamingcorps",
            },
            {
              label: "PixMove",
              key: "/games/provider/pixmove",
            },
            {
              label: "BGaming",
              key: "/games/provider/bgaming",
            },
            {
              label: "UpGaming",
              key: "/games/provider/upgaming",
            },
            {
              label: "Evoplay",
              key: "/games/provider/evoplay",
            },
            {
              label: "Tada Gaming",
              key: "/games/provider/tadagaming",
            },
            {
              label: "Evolution",
              key: "/games/provider/evolution",
            },
          ],
        },
        {
          label: t("categories"),
          key: "category",
          children: [
            {
              label: "Baccarat",
              key: "/games/category/baccarat",
            },
            {
              label: "Blackjack",
              key: "/games/category/blackjack",
            },
            {
              label: "Card",
              key: "/games/category/card",
            },
            {
              label: "Casual",
              key: "/games/category/casual",
            },
            {
              label: "Classic Slots",
              key: "/games/category/classic slots",
            },
            {
              label: "Crash",
              key: "/games/category/crash",
            },
            {
              label: "Dice",
              key: "/games/category/dice",
            },
            {
              label: "Instant",
              key: "/games/category/instant",
            },
            {
              label: "Live Games",
              key: "/games/category/live game",
            },
            {
              label: "Lottery",
              key: "/games/category/lottery",
            },
            {
              label: "Mines",
              key: "/games/category/mines",
            },
            {
              label: "Plinko",
              key: "/games/category/plinko",
            },
            {
              label: "Roulette",
              key: "/games/category/roulette",
            },
            {
              label: "Scratch",
              key: "/games/category/scratch",
            },
            {
              label: "Slots",
              key: "/games/category/slots",
            },
            {
              label: "Smash4Cash",
              key: "/games/category/smash4cash",
            },
            {
              label: "Table",
              key: "/games/category/table",
            },
          ],
        },
      ],
    },
    {
      label: t("miniJuegos"),
      key: "/mini-juegos",
      icon: <IconRocket {...ICON_PROPS} />,
    },
    {
      label: t("casinos"),
      key: "/casino",
      icon: <IconDice5 {...ICON_PROPS} />,
    },
    {
      label: t("gameFeed"),
      key: "/game-feed",
      icon: <IconFlame {...ICON_PROPS} />,
    },
    {
      label: t("lottery"),
      key: "/lottery",
      icon: <IconTicket {...ICON_PROPS} />,
      children: [
        {
          label: "Animalitos",
          key: "/lottery/animalitos",
          icon: <IconPaw {...SUBMENU_ICON_PROPS} />,
        },
        {
          label: "Triples",
          key: "/lottery/triples",
          icon: <IconCircle {...SUBMENU_ICON_PROPS} />,
        },
        {
          label: "Terminales",
          key: "/lottery/terminales",
          icon: <IconPoint {...SUBMENU_ICON_PROPS} />,
        },

        {label: "Ir a Todos", key: "/lottery"},
        // { key: "/lottery/quiniela", label: "Quiniela" },
        // { key: "/lottery/tripleta", label: "Tripleta" },
      ],
    },
    {
      label: t("bingo"),
      key: "/bingo",
      icon: <IconGrid3x3 {...ICON_PROPS} />,
    },
    {
      label: t("horses"),
      key: "/horses",
      icon: <IconHorseshoe {...ICON_PROPS} />,
    },
    // {
    //   label: t("hipism"),
    //   key: "/hipism",
    //   icon: <FontAwesomeIcon icon={faHorseHead} color="white" />,
    // },
    // {
    //   label: t("raffle"),
    //   key: "/raffles",
    //   icon: <FontAwesomeIcon icon={faTicket} color="white" />,
    // },
    {
      label: t("sports"),
      key: "/sports",
      icon: <IconTrophy {...ICON_PROPS} />,
      children: [
        {
          label: t("soccer"),
          key: "/sports?page=soccer",
          icon: <IconTargetArrow {...SUBMENU_ICON_PROPS} />,
        },
        {
          label: t("basketball"),
          key: "/sports?page=basketball",
          icon: <IconCircle {...SUBMENU_ICON_PROPS} />,
        },
        {
          label: t("baseball"),
          key: "/sports?page=baseball",
          icon: <IconCircleDot {...SUBMENU_ICON_PROPS} />,
        },
        {
          label: t("nfl"),
          key: "/sports?page=NFL",
          icon: <IconShield {...SUBMENU_ICON_PROPS} />,
        },
        {
          label: t("allPageSports"),
          key: "/sports",
          icon: <IconTrophy {...SUBMENU_ICON_PROPS} />,
        },
      ],
    },
    {
      label: t("e_sports"),
      key: "/games/pragmatic/vplobby",
      icon: <IconSword {...ICON_PROPS} />,
    },
    {
      label: t("News"),
      key: "/news",
      icon: <IconNews {...ICON_PROPS} />,
    },
    {
      label: t("winnerTestimonials"),
      key: "/testimonios",
      icon: <IconVideo {...ICON_PROPS} />,
    },
    {
      label: t("support"),
      key: "/support",
      icon: <IconHeadset {...ICON_PROPS} />,
      onClick: handleSupportModal,
    },
  ];
  return menuVertical;
};

export const MenuHorizontal = () => {
  const {t} = useTranslation();
  const menuHorizontal = [
    {
      label: t("games"),
      key: "/gameslist/all",
    },
    {
      label: t("live_casino"),
      key: "/live-casino",
    },
    {
      label: t("sports"),
      key: "/sports",
    },
    {
      label: t("bingo"),
      key: "/bingo",
    },
    {
      label: t("horses"),
      key: "/horses",
    },
  ];
  return menuHorizontal;
};
